import InvoiceListCard from "@legacy/invoices/components/InvoiceListCard"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"

import { CardList, Table, ViewBar } from "@organisms"

import { InvoiceTableViewTabs } from "@pages/Invoices/InvoiceList/views/InvoiceTableView/InvoiceTableViewTabs"

import { INVOICES_ROUTES } from "@routes/invoices"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import {
    INVOICES_LIST_CONTROLS_ACTIVE_TAB,
    INVOICES_LIST_CONTROLS_KEYWORD_SEARCH,
    INVOICES_LIST_CONTROLS_ORDERING,
    INVOICES_LIST_CONTROLS_PHASE,
} from "@constants/storage"

export default function InvoiceCardView() {
    const [createRoute] = useSlugExtractor([INVOICES_ROUTES.CREATE])
    const { hasPermission } = useHasAccess()

    return (
        <Table.Provider
            activePhaseStorageKey={INVOICES_LIST_CONTROLS_PHASE}
            activeTabStorageKey={INVOICES_LIST_CONTROLS_ACTIVE_TAB}
            searchKeywordsStorageKey={INVOICES_LIST_CONTROLS_KEYWORD_SEARCH}
            orderingStorageKey={INVOICES_LIST_CONTROLS_ORDERING}
            listTitle="Invoices"
            objectType="invoice"
            objectIndexName="Invoice"
            objectName="Invoice"
            defaultActivePhase="open"
            objectCreateRoute={createRoute}
            isRowClickable={hasPermission("invoices_view_permission", PERMISSION_LEVEL.FULL)}
            isEmptyStateCreateButtonVisible={hasPermission("invoices_create_permission", PERMISSION_LEVEL.RESTRICTED)}
        >
            <ViewBar.Root>
                <ViewBar.Start>
                    <ViewBar.Phases>
                        <Table.Phase phase="open" title="Open" />
                        <Table.Phase phase="closed" title="Closed" />
                    </ViewBar.Phases>
                    <ViewBar.VerticalDivider />
                    <InvoiceTableViewTabs />
                </ViewBar.Start>
                <ViewBar.End>
                    <Table.SearchInput />
                </ViewBar.End>
            </ViewBar.Root>
            <CardList CardComponent={InvoiceListCard} />
        </Table.Provider>
    )
}
